export enum CurrencyCodes {
	GBP = 'GBP',
	EUR = 'EUR',
	USD = 'USD'
}

export enum SupportedCurrencies {
	GBP = '£ - Great British Pounds',
	EUR = '€ - Euros',
	USD = '$ - United States Dollars'
}

export type CurrencyLookup = {
	[key in SupportedCurrencies]: { symbol: string, code: string };
};

export const CurrencyInfo: CurrencyLookup = {
	[SupportedCurrencies.GBP]: { symbol: '£', code: 'GBP' },
	[SupportedCurrencies.EUR]: { symbol: '€', code: 'EUR' },
	[SupportedCurrencies.USD]: { symbol: '$', code: 'USD' }
};

export const currencySymbolForCurrency = (currency: SupportedCurrencies) => CurrencyInfo[currency] ? CurrencyInfo[currency].symbol : '#';

export const currencySymbolForCurrencyString = (currency: string) => {
	const knownSymbol = currencySymbolForCurrency(SupportedCurrencies[currency]);
	if (knownSymbol !== '#')
		return knownSymbol;
	else
		return currency;
};
